var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "url(#pattern0_110_231)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_110_231",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_110_231",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_110_231",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAE/klEQVR4nO2dz2tkRRDHGxJ/sYtidrom6kIQ9bKHPZidrnFVRkTFm3oYBZOdqokxh1WJuorHeFP3JIL/xu6qhxX9AwSJrj8uXqIXf6BuTDxtBJMnNe+JGhJJNt2v673XHygYMsn01JdKd1d3dT9jEolEIpFIJBKJRCKxR/r9sckT3Gk7egaQz1qkC9bRVxZpBRz/ZpH/EMtf00rx3gVAfkv+5khn7oR8xl6baxQTbv4oOHrRIn0AyL8DcnYwo3Xr6H1AXpzoDm4zTeZot3+DdXTKOvoYkDYPLu4u5vhP6+gjwOHsVI+uN03B9k4flkgDRz8EE3cXs45+sUiv3zy9cJOpLdML11hHr1pHq2ULvIPgq4B0Rr6TqRMtx/dbpK9jC7xDX/4NdIcPmaojfSI4eheQtzxE4YZEoe3Q5Mgcv5L/7MCCb4Hjd+589IXrTBVpId8Fjj/3GH1ntrchXZHHCF+2Jwd3mCoh/45+pmn8T0R3aHJ7O63pmVs8dyXrbccPmioAncET1vEV3/2p2a09z+1IMtRGfspoBpAWQs2Jza5t+m8r94GeNRoBR49LchDGcS5Z6FzsVnfwpNGE9GueZgCZHqHzbsS6wSNGzezC88AHSoQuIns9+mxE5p7g6LPwznJEoUe2HHWeXSQjWQOEziSpMbHSah8ZH1RFaOStVnfYK1fl3tK4dfxliU5mCoTOZL2m1IUoz6lvVhWhR+aGL5Ujcu/0YYt8ualCW+TLokF4oZFfKz2KUI/Quy1w+V/2RP4xCc0/yVZcMKGtGwwiOZYpEzqDDj8dUGjZSE1Cg5jji0FElm37kItGUDWhkTaDlDJI3UU8p1ih0LK9xs97F7oobklC47+ERj7nV+V+fwyQ15LQvN3WvJafSS1cZIcypUJnLaRpb0JDl+djO2SUCm1xOPQnNPLZ2A4ZpUKD4ze8CW0dvxfbIaNUaK8DYtlLolAhoQH5kk+hv7va8i0TGIgf0d96c2b/y6KBV7dUCU2/Gl+MjjLsp/ESIlmN0I42TCyhpSbOlATUTOh9dR2y1WWaIjT67DquYjAUscuIbKjVYKhgegd67VKtEhZQal4TFg0pOGg1nyl4cYo1vlOozywS12qZFJRaq8t312rhH3Sa34V/oThbHduxTJP538rKB8TF2I6BMrOOnvMu9JGTc7fGLDcAbSaH+UOt6eS3BChwEhVYqAKaQuhT0R1EJRayJKw421369Q+gz8IWOcYqQgd99rIJTfv47CFZGlTgbBbDSitEF2SrKrbDEM8WTWn0lsYB6YvmRTOVe1hIsDi8r8zjbxDfIhx/K5BDjo2JZkdvm6hHlJGXay8y0qfHjvWvNTGRA+lyMD22GBDO1tpu9najgTbSAyFunYHokTwqs3jYaAIcP1avRSfatI77RiNyPU7Q6y+xJJOA6fK80Yxc+VPlbsQ62lB3xc//Xf1T0QFyTcYbUyUm75mbssifKBAvq+0Fg/+9CmiU1GjOILckGYk+T/aVrluFZWXynWyX7jW1orc0LpeKaFhiLb7DonwnU1fax2cP5Rd18/cRIvhnuah7ws3caJrClGyLdWkGkD4MmujIZzu+KHt8jbp6fiekjloOsFvk8/I0Cg/iytMtzkvdRZnHPKpFvz8m9Wwtx3Pg6E2pBpIa5OJRIKt/Px4kf00r+Xt8Lv/d4XBUC5ceD5JIJBKJRCKRSCQSZs/8BZWX3DzLqHf7AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.a93f8f0c7f1f76a4d418eee4259bf3f6.svg";
export { ForwardRef as ReactComponent };